import { cva, VariantProps } from "class-variance-authority";

export const alertVariants = cva(
  "tw-relative tw-w-full tw-border tw-flex tw-flex-col tw-gap-4 tw-pl-16 tw-pr-12 tw-py-14 [&>svg]:tw-absolute [&>svg]:tw-left-12 [&>svg]:tw-top-12 has-[>svg]:tw-pl-40",
  {
    variants: {
      appearance: {
        purple:
          "tw-bg-purple-200 tw-border-purple-300 tw-text-purple-800 *:data-[slot=alert-description]:tw-text-purple-800/90",
        white:
          "tw-bg-white tw-border-gray-400 tw-text-black *:data-[slot=alert-description]:tw-text-black",
        yellow:
          "tw-bg-yellow-200 tw-border-yellow-900 tw-text-yellow-900 *:data-[slot=alert-description]:tw-text-yellow-900/90",
        red: "tw-bg-red-100 tw-border-red-400 tw-text-red-900 *:data-[slot=alert-description]:tw-text-red-900/90",
        green:
          "tw-bg-green-100 tw-border-green-700 tw-text-green-900 *:data-[slot=alert-description]:tw-text-green-900",
      },
      isDismissable: {
        true: "tw-pr-56",
      },
      flush: {
        true: "tw-border-0 tw-rounded-none",
        false: "tw-rounded-8",
      },
      iconPlacement: {
        top: "[&>svg]:tw-top-12",
        center: "[&>svg]:tw-top-1/2 [&>svg]:-tw-translate-y-1/2",
      },
    },
    defaultVariants: {
      flush: false,
    },
  },
);

export const alertDismissButtonVariants = cva(
  "tw-absolute tw-right-12 tw-top-12",
  {
    variants: {
      appearance: {
        purple: "tw-text-purple-800 hover:tw-text-purple-800",
        white: "tw-text-black hover:tw-text-black",
        yellow: "tw-text-yellow-900 hover:tw-text-yellow-900",
        red: "tw-text-red-900 hover:tw-text-red-900",
        green: "tw-text-green-900 hover:tw-text-green-900",
      },
    },
  },
);

export type AlertVariantProps = VariantProps<typeof alertVariants>;
